import {NgModule} from "@angular/core";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {ToastrModule} from "ngx-toastr";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


const translateModule =
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
        }
    });
const toastrModule = ToastrModule.forRoot({
    autoDismiss: true,
    maxOpened: 1,
    timeOut: 2000,
    positionClass: 'toast-top-center',
    enableHtml: true
});

@NgModule({
    imports: [HttpClientModule, translateModule, toastrModule],
    providers: [],
    exports: [TranslateModule, ToastrModule]

})
export class CommonAppModule {

}



// WEBPACK FOOTER //
// ./src/app/common/common-app.module.ts